<script>
import Vue from "vue";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Swal from "sweetalert2";
import Multiselect from "vue-multiselect";
import DatePicker from "vue2-datepicker";
import simplebar from "simplebar-vue";
import axios from "axios";
import { FormWizard, TabContent } from "vue-form-wizard";
/**
 * Projects-list component
 */
export default {
  page: {
    title: "Projects List",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    DatePicker,
    Multiselect,
    FormWizard,
    TabContent,
    simplebar,
  },
  data() {
    return {
      title: "Projects List",
      selectAllProject: false,
      addProjectModal : false,
      editProjectModal : false,
      markCompleteModal : false,
      membersModal : false,
      todaysReportModal : false,
      projectLoader : false,
      membersLoader : false,
      todaysReportLoader : false,
      reportsDate: null,
      selectedDate: "",
      currProject: {},
      loginData: {},
      projects: [],
      vacantProject: {
        projectName: '',
        projectDescription: '',
        startTime: null,
        deadlineTime: null,
        recordScreenshot: true,
        recordWebcam: false,
        mandatoryReporting: true,
        employees: [],
        teams: [],
        manager: '',
        isBillable: false,
        billingType: 0,
        payRate: 0,
        billingCurrency: 1,
        expectedTotalBudget: 0,
      },
      addedProject: {
        projectName: '',
        projectDescription: '',
        startTime: '2020-02-12T22:00',
        deadlineTime: '2020-02-12T22:00',
        recordScreenshot: true,
        recordWebcam: false,
        mandatoryReporting: true,
        employees: [],
        teams: [],
        manager: '',
        isBillable: false,
        billingType: 0,
        payRate: 0,
        billingCurrency: 1,
        expectedTotalBudget: 0,
      },
      editProject: {
        projectId : '',
        projectName: '',
        projectDescription: '',
        startTime: null,
        deadlineTime: null,
        recordScreenshot: true,
        recordWebcam: false,
        mandatoryReporting: true,
        employees: [],
        teams: [],
        manager: '',
        isBillable: false,
        billingType: 0,
        payRate: 0,
        billingCurrency: 1,
        expectedTotalBudget: 0,
      },
      markCompleteData: {
        projectId : '',
        score: 0,
        comments: '',
      },
      projectMembers: [
        /*{
          name: 'Abhilash Aman',
          email: 'test@gmail.com',
          designation: 'Software Developer',
          totalTime: '20 Hrs',
          currencyType: 1,
          totalExpense: '150',
          lastReport: 'Worked for 02 Hrs on 02 Oct 22 between 12:00 and 17:00',
          percentCompleted: '10',
          workDone: 'I have done project Management part and completed all the api',
          toDo: 'Will solve screenshot api and country timezone problem',
          remarks: 1,
        },
        {
          name: 'Abhilash Aman1',
          email: 'test@gmail.com',
          designation: 'Software Developer',
          totalTime: '40 Hrs',
          currencyType: 2,
          totalExpense: '270',
          lastReport: 'Worked for 02 Hrs on 02 Oct 22 between 12:00 and 17:00',
          percentCompleted: '50',
          workDone: 'I have done project Management part and completed all the api',
          toDo: 'Will solve screenshot api and country timezone problem',
          remarks: 2,
        },
        {
          name: 'Abhilash Aman2',
          email: 'test@gmail.com',
          designation: 'Software Developer',
          totalTime: '10 Hrs',
          currencyType: 1,
          totalExpense: '330',
          lastReport: 'Worked for 02 Hrs on 02 Oct 22 between 12:00 and 17:00',
          percentCompleted: '',
          workDone: '',
          toDo: '',
          remarks: 3,
        },
        {
          name: 'Abhilash Aman3',
          email: 'test@gmail.com',
          designation: 'Software Developer',
          totalTime: '20 Min',
          currencyType: 2,
          totalExpense: '10',
          lastReport: 'Worked for 02 Hrs on 02 Oct 22 between 12:00 and 17:00',
          percentCompleted: '',
          workDone: '',
          toDo: '',
          remarks: 4,
        }*/
      ],
      todaysReport: [
      ],
      errorMsg: '',
      errorCode: 0,
      errorEditCode: 0,
      errorEditMsg: '',
      series: [0, 50],
      chartOptions: {
        chart: {
          type: "donut",
        },
        dataLabels: {
          enabled: false,
        },
        tooltip: {
          enabled: false,
        },
        legend: {
          show: false,
        },
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: false,
              },
              size: "65%",
            },
          },
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 100,
              },
            },
          },
        ],
        colors: ["#f8f9fa", "#4287f5"],
      },
      filterValue: "",
      filters: {
        showMarkCompleted : false,
        showDelayed : false,
        showProgressLess40 : false,
        showProgressMore70 : false,
        showProgressMore100 : false,
      },
      submitted: false,
      employeeOptions: [
      ],
      teamOptions: [
      ],
      managerOptions: [
      ],
    }
  },
  methods: {
    /**
     * Modal form submit
     */
    // eslint-disable-next-line no-unused-vars
    onDateChange() {
      if(this.reportsDate != null){
        var date = new Date(this.reportsDate),
        mnth = ("0" + (date.getMonth() + 1)).slice(-2),
        day = ("0" + date.getDate()).slice(-2);
        this.selectedDate = [date.getFullYear(), mnth, day].join("-");
        this.getTodaysReport();
      } else {
        this.selectedDate = "";
      }
    },
    selectAllProjectCheckbox() {
      for(var i =0;i< this.projects.length;i++) {
        this.projects[i].isChecked = this.selectAllProject;
      }
    },
     async getAllTeams() {
      try {
        const response = await axios.get(process.env.VUE_APP_EMPLOYEE_URL + "/team/get_all", {
          params: { companyId: this.loginData.companyId },
        });
        if(response.data.success == "true") {
          for (var i = 0; i < response.data.data.length; i++) {
            var d = {};
            d.value = response.data.data[i].teamId;
            d.text = response.data.data[i].teamName;

            this.teamOptions.push(d);
          }
        }
      } catch (error) {
        //console.log(error);
      }
    },
    async getAllEmployees() {
      try {
        const response = await axios.get(process.env.VUE_APP_EMPLOYEE_URL + "/employee/get_all",
          { params: { companyId: this.loginData.companyId } }
        );
        if(response.data.success == "true") {
          for (var i = 0; i < response.data.data.length; i++) {
            var d = {};
            d.value = response.data.data[i].empId;
            d.text = response.data.data[i].name;
            
            this.employeeOptions.push(d);
          }
        }
      } catch (error) {
        //console.log(error);
      }
      this.empLoader = false;
    },
    async getAllProjects() {
      this.projectLoader = true;
      try {
        const response = await axios.get(process.env.VUE_APP_EMPLOYEE_URL + "/project/get_all",
          { params: { companyId: this.loginData.companyId } }
        );
        console.log(response.data);
        if(response.data.success == "true") {
          if(response.data.data.length > 0) {
            this.projects = response.data.data;
            console.log(this.projects);
            for(var i = 0;i < this.projects.length; i++) {
              this.projects[i].isChecked = false;
            }
          }
        }
        this.projectLoader = false;
      } catch (error) {
        //console.log(error);
        this.projectLoader = false;
      }
      this.projectLoader = false;
    },
    handleAddProjectSubmit() {
      this.addedProject.companyId = this.loginData.companyId;
      var d = {};
      if(this.addedProject.manager) {
        d.value = this.addedProject.manager.value;
        d.text = this.addedProject.manager.text;
        this.addedProject.employees.push(d);
      }

      this.addedProject.startTime = new Date(this.addedProject.startTime).getTime();
      this.addedProject.deadlineTime = new Date(this.addedProject.deadlineTime).getTime();
      if(this.addedProject.recordScreenshot == true) {
        this.addedProject.recordScreenshot = 1;
      } else {
        this.addedProject.recordScreenshot = 0;
      }
      if(this.addedProject.recordWebcam == true) {
        this.addedProject.recordWebcam = 1;
      } else {
        this.addedProject.recordWebcam = 0;
      }
      if(this.addedProject.mandatoryReporting == true) {
        this.addedProject.mandatoryReporting = 1;
      } else {
        this.addedProject.mandatoryReporting = 0;
      }
      if(this.addedProject.isBillable == true) {
        this.addedProject.isBillable = 1;
      } else {
        this.addedProject.isBillable = 0;
      }


      let formData = new FormData();
      formData.append("companyId", this.loginData.companyId);
      formData.append("project", JSON.stringify(this.addedProject));

      axios
          .post(process.env.VUE_APP_EMPLOYEE_URL + `/project/add`, formData)
          .then((res) => {
            if(res.data.success == "true") {
              this.addProjectModal = false;
              Swal.fire({
                title: "Added!",
                text: "Project has been Added.",
                icon: 'success',
                onClose: () => {
                  let dupProject = res.data.data;
                  this.projects.push(dupProject);
                  this.addedProject = JSON.parse(JSON.stringify(this.vacantProject));
                }
              });
              
            } else {
              this.addProjectModal = false;
              Vue.swal(res.data);
            }
            return res;
          })
          .catch((err) => {
            this.addProjectModal = false;
            Vue.swal("Oops! Some Error Occured.");
            return err;
          });
    },
    handleEditProjectSubmit() {
      this.editProject.companyId = this.loginData.companyId;
      var d = {};
      if(this.editProject.manager) {
        d.value = this.editProject.manager.value;
        d.text = this.editProject.manager.text;
        this.editProject.employees.push(d);
      }
      this.editProject.startTime = new Date(this.editProject.startTime).getTime();
      this.editProject.deadlineTime = new Date(this.editProject.deadlineTime).getTime();
      if(this.editProject.recordScreenshot == true) {
        this.editProject.recordScreenshot = 1;
      } else {
        this.editProject.recordScreenshot = 0;
      }
      if(this.editProject.recordWebcam == true) {
        this.editProject.recordWebcam = 1;
      } else {
        this.editProject.recordWebcam = 0;
      }
      if(this.editProject.mandatoryReporting == true) {
        this.editProject.mandatoryReporting = 1;
      } else {
        this.editProject.mandatoryReporting = 0;
      }
      if(this.editProject.isBillable == true) {
        this.editProject.isBillable = 1;
      } else {
        this.editProject.isBillable = 0;
      }

      console.log(JSON.stringify(this.editProject));
      let formData = new FormData();
      formData.append("companyId", this.loginData.companyId);
      formData.append("project", JSON.stringify(this.editProject));
      
      axios
          .post(process.env.VUE_APP_EMPLOYEE_URL + `/project/edit`, formData)
          .then((res) => {
            if(res.data.success == "true") {
              this.editProjectModal = false;
              Swal.fire({
                title: "Edited!",
                text: "Project has been Edited.",
                icon: 'success',
                onClose: () => {
                  let index = this.getIndexByProjectId(this.editProject.projectId);
                  let progress = this.projects[index].progress;
                  let timeSpent = this.projects[index].timeSpent;
                  let expense = this.projects[index].expense;
                  this.projects[index] = res.data.data;
                  this.projects[index].progress = progress;
                  this.projects[index].timeSpent = timeSpent;
                  this.projects[index].expense = expense;
                  this.editProject = JSON.parse(JSON.stringify(this.vacantProject));
                }
              });
              
            } else {
              this.editProjectModal = false;
              Vue.swal(res.data);
            }
            return res;
          })
          .catch((err) => {
            this.editProjectModal = false;
            Vue.swal("Oops! Some Error Occured.");
            return err;
          });
    },
    getCurrentDateTime() {

    },
    handleMarkCompleteSubmit() {

      let formData = new FormData();
      formData.append("projectId", this.markCompleteData.projectId);
      formData.append("score", this.markCompleteData.score);
      formData.append("comments", this.markCompleteData.comments);

      axios
        .post(process.env.VUE_APP_EMPLOYEE_URL + `/project/mark_complete`, formData)
        .then((res) => {
          if(res.data.success == "true") {
            this.markCompleteModal = false;
            Swal.fire({
              title: "Saved!",
              text: "Project has been Marked Completed.",
              icon: 'success',
              onClose: () => {
                let index = this.getIndexByProjectId(this.markCompleteData.projectId);
                this.projects[index].status = 2;
                this.projects[index].score = this.markCompleteData.score;
                this.projects[index].comments = this.markCompleteData.comments;
                this.projects[index].completionTime = res.data.data.completionTime;
                this.markCompleteData.completionDateTime = res.data.data.completionDateTime;

                this.markCompleteData.projectId = '';
                this.markCompleteData.score = '';
                this.markCompleteData.comments = '';
                
              }
            });
            
          } else {
            this.markCompleteModal = false;
            Vue.swal(res.data);
          }
          return res;
        })
        .catch((err) => {
          this.markCompleteModal = false;
          Vue.swal("Oops! Some Error Occured.");
          return err;
        });
    },
    getIndexByProjectId(projectId) {
      for(var i = 0;i < this.projects.length;i++) {
        if(this.projects[i].projectId == projectId) {
          return i;
        }
      }
    },
    openEditProjectModal(data) {
      this.editProject.projectId = data.projectId;
      this.editProject.projectName = data.projectName;
      this.editProject.projectDescription = data.projectDescription;
      this.editProject.startTime = data.startDateTimeLocal;
      this.editProject.deadlineTime = data.deadlineDateTimeLocal;
      this.editProject.recordScreenshot = data.recordScreenshot;
      this.editProject.recordWebcam = data.recordWebcam;
      this.editProject.mandatoryReporting = data.mandatoryReporting;
      this.editProject.employees = data.employees;
      this.editProject.teams = data.teams;
      this.editProject.manager = data.manager;
      this.editProject.isBillable = data.isBillable;
      this.editProject.billingType = data.billingType;
      this.editProject.payRate = data.payRate;
      this.editProject.billingCurrency = data.billingCurrency;
      this.editProject.expectedTotalBudget = data.expectedTotalBudget;
      this.errorEditCode = 0;
      this.errorEditMsg = '';
      this.editProjectModal = true;
    },
    openMarkCompleteModal(data) {
      this.markCompleteData.projectId = data.projectId;
      this.markCompleteModal = true;
    },
    openMembersModal(project) {
      this.membersModal = true;
      this.getMembers(project.projectId);
    },
    async getMembers(projectId) {
      this.membersLoader = true;
      try {
        const response = await axios.get(process.env.VUE_APP_EMPLOYEE_URL + "/project/members",
          { params: { projectId: projectId } }
        );
        console.log(response.data);
        if(response.data.success == "true") {
          if (response.data.data.length > 0) {
            this.projectMembers = response.data.data;
          }
        }
      } catch (error) {
        //console.log(error);
      }
      this.membersLoader = false;
    },
    openTodaysReportModal(project) {
      this.currProject = project;
      var date = new Date(),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    
      this.selectedDate = [date.getFullYear(), mnth, day].join("-");
      this.reportsDate = new Date();
      this.todaysReportModal = true;
      this.getTodaysReport();
    },
     async getTodaysReport() {
      this.todaysReportLoader = true;
      this.todaysReport = [];
      try {
        const response = await axios.get(process.env.VUE_APP_EMPLOYEE_URL + "/project/todays_report",
          { params: { projectId:  this.currProject.projectId, date: this.selectedDate } }
        );
        console.log(response.data);
        if(response.data.success == "true") {
          if (response.data.data.length > 0) {
            this.todaysReport = response.data.data;
          }
        }
      } catch (error) {
        //console.log(error);
      }
      this.todaysReportLoader = false;
    },
    validateTextField(data) {
      if(data == null) {
        return false;
      }
      if(data == '') {
        return false;
      }
      return true;
    },
    validateDateRangeField(date1, date2) {
      if(date1 == null || date2 == null) {
        return false;
      }
      if(date1 == '' || date2 == '') {
        return false;
      }
      let startTimestamp = new Date(date1).getTime();
      let endTimestamp = new Date(date2).getTime();
      if(startTimestamp >= endTimestamp) {
        return false;
      }
      return true;
    },
    async beforeTabSwitch() {
        let flag = true;
        this.errorCode = 0;
        await new Promise((resolve, reject) => {
          setTimeout(() => {
            
            if(!this.validateTextField(this.addedProject.projectName)) {
              this.errorCode += 1;
            }
            if(!this.validateDateRangeField(this.addedProject.startTime, this.addedProject.deadlineTime)) {
              this.errorCode += 2;
            }
            
            if(this.errorCode > 0) {
              reject("Please fill the Form Correctly.");
            } else {
              resolve(); 
            }          
          }, 10);
        }).then(() => {
          flag = true;
          this.errorMsg = '';
        }).catch((err) => {
          flag = false;
          this.errorMsg = err;
        });
        return flag;
      },
      async beforeTabSwitchEdit() {
        let flag = true;
        this.errorEditCode = 0;
        await new Promise((resolve, reject) => {
          setTimeout(() => {
            
            if(!this.validateTextField(this.editProject.projectName)) {
              this.errorEditCode += 1;
            }
            if(!this.validateDateRangeField(this.editProject.startTime, this.editProject.deadlineTime)) {
              this.errorEditCode += 2;
            }
            
            if(this.errorEditCode > 0) {
              reject("Please fill the Form Correctly.");
            } else {
              resolve(); 
            }          
          }, 10);
        }).then(() => {
          flag = true;
          this.errorEditMsg = '';
        }).catch((err) => {
          flag = false;
          this.errorEditMsg = err;
        });
        return flag;
      },
      nameWithLang({ text }) {
      return `${text}`;
    },
    confirm() {
      let ischeckedProject = false;
      let sendData = "";

      for(var i = 0;i < this.projects.length;i++) {
        if(this.projects[i].isChecked == true) {
          ischeckedProject = true;
          sendData = sendData.concat(",", this.projects[i].projectId);
        }
      }
      sendData = sendData.substring(1);

      if(ischeckedProject == false) {
        Vue.swal("Please Select Project.");
      } else {
        Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#34c38f",
          cancelButtonColor: "#f46a6a",
          confirmButtonText: "Yes, delete it!"
        }).then(result => {
          if (result.value) {
            this.deleteProjects(sendData);
          }
        });
      }
    },
    deleteProjects(sendData) {
      let formData = new FormData();
      formData.append("projectIds", sendData);
      formData.append("companyId", this.loginData.companyId);
      axios
          .post(process.env.VUE_APP_EMPLOYEE_URL + `/project/delete`, formData)
          .then((res) => {
            if(res.data.success == "true") {
                this.getAllProjects();
                Swal.fire("Deleted!", "Project(s) have been deleted.", "success");
              } else {
                Vue.swal(res.data);
              }
            return res;
          })
          .catch((err) => {
            Vue.swal("Oops! Some Error Occured.");
            return err;
          });
    },
  },
  created() {
    
    this.loginData = JSON.parse(localStorage.getItem('user'));
    this.getAllProjects();
    this.getAllEmployees();
    this.getAllTeams();
  },
  computed: {
    searchevents: function(){
      var result = this.projects;
      if (!this.filterValue)
        return result;
        
      const filterValue = this.filterValue.toLowerCase();

      const filter = event => 
          event.projectName.toLowerCase().includes(filterValue);
      
      return result.filter(filter);
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="$t('menuitems.projects.text')"/>
    <div class="row mb-1">
      <div class="col-sm-4">
        <div class="search-box mb-2">
        <div class="position-relative">
          <input
            type="text"
            class="form-control"
            :placeholder="$t('menuitems.projects.search')"
            v-model="filterValue"
          />
          <i class="bx bx-search-alt search-icon"></i>
        </div>
      </div>
      </div>
      <div class="col-sm-8">
        <div class="text-sm-end">
          <button @click="addProjectModal = true;" class="btn btn-success mb-2 me-2">
            <i class="mdi mdi-plus me-1"></i> {{ $t('menuitems.projects.add') }}
          </button>
          <button class="btn btn-danger mb-2 me-2" @click="confirm">
          <i class="mdi mdi-account-remove"></i> {{ $t('menuitems.projects.remove') }}
          </button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
       
           <div class="is-loading">
              <div class="preloader-component" v-show="projectLoader">
                <div class="status">
                  <div class="spinner-chase">
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                  </div>
                </div>
              </div>
            <div style="height: calc(100vh - 290px)">
            <simplebar style="max-height: calc(100vh - 290px)">
            <div class="table-responsive">
              <table
                class="table project-list-table table-nowrap table-centered table-borderless align-middle"
              >
                <thead>
                  <tr>
                    <th scope="col" style="width: 70px"><input
                            type="checkbox"
                            class="form-check form-check-input font-size-6"
                            v-model="selectAllProject"
                            @change="selectAllProjectCheckbox"
                          /></th>
                    <th scope="col">{{ $t('menuitems.projects.project') }}</th>
                    <th scope="col">{{ $t('menuitems.projects.members') }}</th>
                    <th scope="col">{{ $t('menuitems.projects.dueDate') }}</th>
                    <th scope="col">{{ $t('menuitems.projects.progress') }}</th>
                    <th scope="col">{{ $t('menuitems.projects.timeSpent') }}</th>
                    <th scope="col">{{ $t('menuitems.projects.expense') }}</th>
                    <!-- <th scope="col">Team</th> -->
                    <th scope="col">{{ $t('menuitems.projects.action') }}</th>
                  </tr>
                </thead>
                <tbody v-if="searchevents.length > 0">
                  <tr v-for="project in searchevents" :key="project.projectId">
                    <td>
                      <div class="form-check font-size-16">
                          <input
                            type="checkbox"
                            class="form-check-input"
                            v-model="project.isChecked"
                          />
                          <label
                            class="form-check-label"
                            >&nbsp;</label
                          >
                        </div>
                    </td>
                    <td>
                      <h5 class="text-truncate font-size-14">
                        <a href="javascript: void(0);" class="text-dark">{{
                          project.projectName
                        }}</a>
                      </h5>
                      <p class="text-muted mb-0">{{ project.projectDescription }}</p>
                    </td>
                    <td>
                      <div v-if="project.employees.length <= 0">
                        <img src="@/assets/images/no-data.png" alt="No Data"  height="50" width="60">
                      </div>
                      <div v-else class="avatar-group">
                        <div class="avatar-group-item" v-if="project.employees.length >= 1" role="button" @click="openMembersModal(project)">
                            <div class="avatar-xs">
                              <span class="avatar-title rounded-circle bg-soft bg-success text-primary">{{
                                project.employees[0].text.charAt(0)
                              }}</span>
                            </div>
                        </div>
                        <div class="avatar-group-item" v-if="project.employees.length >= 2" role="button" @click="openMembersModal(project)">
                          <div class="avatar-xs">
                            <span class="avatar-title rounded-circle bg-soft bg-primary text-primary">{{
                              project.employees[1].text.charAt(0)
                            }}</span>
                          </div>
                        </div>
                        <div class="avatar-group-item" v-if="project.employees.length >= 3" role="button" @click="openMembersModal(project)">
                          <div class="avatar-xs">
                            <span class="avatar-title rounded-circle bg-soft bg-warning text-primary">{{
                              project.employees[2].text.charAt(0)
                            }}</span>
                          </div>
                        </div>
                        <div class="avatar-group-item" v-if="project.employees.length >= 4" role="button" @click="openMembersModal(project)">
                          <div class="avatar-xs">
                            <span class="avatar-title rounded-circle bg-soft bg-warning text-primary">{{
                              project.employees[3].text.charAt(0)
                            }}</span>
                          </div>
                        </div>
                      </div>
                    </td> 
                    <td>{{ project.deadlineDateTime }}</td>
                    <td v-if="project.status != 2">
                      <b-progress v-if="project.progress < 25" :value="project.progress" :max="100" variant="danger" show-value animated></b-progress>
                      <b-progress v-if="project.progress >= 25 && project.progress < 50" :value="project.progress" :max="100" variant="warning" show-value animated></b-progress>
                      <b-progress v-if="project.progress >= 50 && project.progress < 75" :value="project.progress" :max="100" variant="primary" show-value animated></b-progress>
                      <b-progress v-if="project.progress >= 75 && project.progress <= 100" :value="project.progress" :max="100" variant="success" show-value animated></b-progress>
                    </td>
                    <td v-if="project.status == 2">
                    <span class="badge badge-soft-primary font-size-13">{{ $t('menuitems.projects.completed') }}</span>
                    <br/> <span class="text-danger" v-if="project.completionTime >= project.deadlineTime">({{ project.completionDateTime }})</span>
                    <span class="text-success" v-else>({{ project.completionDateTime }})</span>
                    </td>
                    <td>
                      {{ project.timeSpent }} {{ project.timeSpentUnit }}
                    </td>
                    <td>
                      <span v-if="project.billingCurrency == 1">$</span><span v-else>₹</span> {{ project.expense }}
                    </td>
                    <td>
                      <b-dropdown
                        class="card-drop"
                        variant="white"
                        menu-class="dropdown-menu-end"
                        right
                        toggle-class="p-0"
                      >
                        <template v-slot:button-content>
                          <i class="mdi mdi-dots-horizontal font-size-18"></i>
                        </template>
                        <b-dropdown-item href="javascript: void(0);" @click="openEditProjectModal(project)"
                          ><i class="bx bx-edit-alt me-2"></i> {{ $t('menuitems.projects.edit') }}</b-dropdown-item
                        >
                        <!--<b-dropdown-item href="javascript: void(0);"
                          ><i class="bx bxs-detail me-2"></i> View Details</b-dropdown-item
                        >-->
                        <b-dropdown-item href="javascript: void(0);" @click="openTodaysReportModal(project)"
                          ><i class="bx bxs-report me-2"></i> {{ $t('menuitems.projects.todaysReport') }}</b-dropdown-item
                        >
                        <b-dropdown-item href="javascript: void(0);" v-if="project.status != 2" @click="openMarkCompleteModal(project)"
                          ><i class="bx bxs-check-circle me-2"></i> {{ $t('menuitems.projects.markComplete') }}</b-dropdown-item
                        >
                        <b-dropdown-item href="javascript: void(0);" v-if="project.status == 2" disabled>
                          <i class="bx bxs-check-circle me-2"></i> {{ $t('menuitems.projects.markedComplete') }}</b-dropdown-item
                        >
                        <!--<b-dropdown-item href="javascript: void(0);"
                          ><i class="bx bx-trash-alt me-2"></i> Remove</b-dropdown-item
                        >-->
                      </b-dropdown>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <div style="margin-top: 82%;margin-left: 270%;">
                    <img src="@/assets/images/no-data.png" alt="No Data"  height="180" width="180">
                </div>
                </tbody>
              </table>
            </div>
            </simplebar>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->

    <b-modal v-model="addProjectModal" size="lg" :title="$t('menuitems.projects.add')" hide-footer>
      <form-wizard @on-complete="handleAddProjectSubmit" color="#556ee6" title="Members" :finish-button-text="$t('menuitems.projects.form.finish')" :back-button-text="$t('menuitems.projects.form.back')" :next-button-text="$t('menuitems.projects.form.next')">
              <tab-content :before-change="beforeTabSwitch" icon="bx bx-food-menu" style="height: 288px;" :title="$t('menuitems.projects.form.general')">
                <div class="text-danger mb-2">{{errorMsg}}</div>
                <div class="row">
                  <div class="col-12">
                    <div class="form-group row mb-3">
                      <label class="col-md-4 col-form-label" for="projectName"
                        >{{ $t('menuitems.projects.form.title') }} <sup><i class="mdi mdi-asterisk text-danger font-size-2"></i></sup></label
                      >
                      <div class="col-md-8">
                        <input
                          type="text"
                          class="form-control"
                          v-model="addedProject.projectName"
                          name="projectName"
                          :class="{
                          'is-invalid':
                            errorCode == 1 || errorCode == 3
                          }"
                        />
                      </div>
                    </div>
                    <div class="form-group row mb-3">
                      <label class="col-md-4 col-form-label" for="description"
                        >{{ $t('menuitems.projects.form.description') }}</label
                      >
                      <div class="col-md-8">
                        <textarea
                          name="description"
                          class="form-control"
                          v-model="addedProject.projectDescription"
                        ></textarea>
                      </div>
                    </div>

                    <div class="form-group row mb-3">
                      <label class="col-md-4 col-form-label" for="startDate"
                        > {{ $t('menuitems.projects.form.date') }} <sup><i class="mdi mdi-asterisk text-danger font-size-2"></i></sup></label
                      >
                      <div class="col-md-4">
                      <b-form-input
                      type="datetime-local"
                      v-model="addedProject.startTime"
                      :class="{
                          'is-invalid':
                            errorCode == 2 || errorCode == 3
                          }"
                    ></b-form-input>
                      </div>
                      
                      <div class="col-md-4">
                     <b-form-input
                      v-model="addedProject.deadlineTime"
                      type="datetime-local"
                      :class="{
                          'is-invalid':
                            errorCode == 2 || errorCode == 3
                          }"
                    ></b-form-input>
                      </div>
                    </div>
                    <div class="form-group row mb-3">
                      <label class="col-md-4 col-form-label" for="startDate"
                        >{{ $t('menuitems.projects.form.recordActivity') }}</label
                      >
                      
                      <div class="form-check form-switch form-switch-md ms-2 mt-2 col-md-1">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          v-model="addedProject.recordScreenshot"
                          disabled
                        />
                      </div>
                      <label class="col-md-2 mt-1 col-form-label" for="screenshot"
                        >{{ $t('menuitems.projects.form.screenshot') }}</label
                      >
                      <div class="col-md-1"></div>
                       <div class="form-check form-switch form-switch-md mt-2 col-md-1">
                      
                        <!--<input
                          class="form-check-input"
                          type="checkbox"
                          v-model="addedProject.recordWebcam"
                        />-->
                      
                      </div>
                      <!--<label class="col-md-2 mt-1 col-form-label" for="webcam"
                        >{{ $t('menuitems.projects.form.webcam') }}</label
                      >-->
                    </div>
                    <div class="form-group row mb-3">
                      <label class="col-md-4 col-form-label" for="startDate"
                        >{{ $t('menuitems.projects.form.mandatoryReporting') }}</label
                      >
                      
                      <div class="form-check form-switch form-switch-md ms-2 mt-2 col-md-1">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          v-model="addedProject.mandatoryReporting"
                        />
                      </div>
                      
                    </div>
                  </div>
                  <!-- end col -->
                </div>
                <!-- end row -->
              </tab-content>
              <tab-content icon="bx bx-user-circle" style="height: 288px;" :title="$t('menuitems.projects.form.members')">
                <div class="row">
                  <div class="col-12">
                    <div class="form-group row mb-5">
                      <label class="col-md-3 col-form-label" for="name"
                        >{{ $t('menuitems.projects.form.addMembers') }}</label
                      >
                      <div class="col-md-9">
                        <multiselect v-model="addedProject.employees" :options="employeeOptions" :custom-label="nameWithLang" :multiple="true"></multiselect>
                      </div>
                    </div>
                    <div class="form-group row mb-5">
                      <label class="col-md-3 col-form-label" for="surname"
                        >{{ $t('menuitems.projects.form.assignTeam') }}</label
                      >
                      <div class="col-md-9">
                       <multiselect v-model="addedProject.teams" :options="teamOptions" :custom-label="nameWithLang" :multiple="true"></multiselect>
                      </div>
                    </div>

                    <div class="form-group row mb-5">
                      <label class="col-md-3 col-form-label" for="email"
                        >{{ $t('menuitems.projects.form.assignManager') }}</label
                      >
                      <div class="col-md-9">
                        <multiselect v-model="addedProject.manager" :custom-label="nameWithLang" :options="employeeOptions" ></multiselect>
                      </div>
                    </div>
                  </div>
                  <!-- end col -->
                </div>
                <!-- end row -->
              </tab-content>
              <tab-content icon="bx bx-money" style="height: 288px;" :title="$t('menuitems.projects.form.budget')">
                <div class="row">
                  <div class="form-group row mb-3">
                      <label class="col-md-3 col-form-label" for="startDate"
                        >{{ $t('menuitems.projects.form.isBillable') }}</label
                      >
                      
                      <div class="form-check form-switch form-switch-md ms-2 mt-2 col-md-1">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          v-model="addedProject.isBillable"
                        />
                      </div>
                      
                  </div>
                  <div class="form-group row mb-3">
                      <label class="col-md-3 col-form-label" for="startDate"
                        >{{ $t('menuitems.projects.form.billingType') }}</label
                      >
                      <div class="col-md-5">
                      <b-form-select
                          class="form-select mb-3"
                          :disabled="addedProject.isBillable == false"
                          v-model="addedProject.billingType"
                        >
                          <b-form-select-option :value="0"
                            >{{ $t('menuitems.projects.form.select') }}</b-form-select-option
                          >
                          <b-form-select-option value="1"
                            >{{ $t('menuitems.projects.form.fixed') }}</b-form-select-option
                          >
                          <b-form-select-option value="2"
                            >{{ $t('menuitems.projects.form.hourly') }}</b-form-select-option
                          >
                      </b-form-select>
                      </div>
                  </div>
                  <div class="form-group row mb-3">
                      <label class="col-md-3 col-form-label" for="startDate"
                        >{{ $t('menuitems.projects.form.payRate') }}</label
                      >
                      <div class="col-md-2">
                      <b-form-select
                          class="form-select mb-3"
                          :disabled="addedProject.isBillable == false"
                          v-model="addedProject.billingCurrency"
                        >
                          <b-form-select-option :value="0"
                            >{{ $t('menuitems.projects.form.select') }}</b-form-select-option
                          >
                          <b-form-select-option value="1"
                            >USD($)</b-form-select-option
                          >
                          <b-form-select-option value="2"
                            >INR(₹)</b-form-select-option
                          >
                      </b-form-select>
                      </div>
                      <div class="col-md-3">
                       <input
                          type="text"
                          class="form-control"
                          :disabled="addedProject.isBillable == false"
                          v-model="addedProject.payRate"
                        />
                      </div>
                  </div>
                  <div class="form-group row mb-3">
                      <label class="col-md-3 col-form-label" for="startDate"
                        >{{ $t('menuitems.projects.form.expectedTotalBudget') }}</label
                      >
                      <div class="col-md-2">
                      <b-form-select
                          class="form-select mb-3"
                          :disabled="addedProject.isBillable == false"
                          v-model="addedProject.billingCurrency"
                        >
                          <b-form-select-option :value="0"
                            >{{ $t('menuitems.projects.form.select') }}</b-form-select-option
                          >
                          <b-form-select-option value="1"
                            >USD($)</b-form-select-option
                          >
                          <b-form-select-option value="2"
                            >INR(₹)</b-form-select-option
                          >
                      </b-form-select>
                      </div>
                      <div class="col-md-3">
                       <input
                          type="text"
                          class="form-control"
                          :disabled="addedProject.isBillable == false"
                          v-model="addedProject.expectedTotalBudget"
                        />
                      </div>
                  </div>
                  <!-- end col -->
                </div>
                <!-- end row -->
              </tab-content>
            </form-wizard>
    </b-modal>

    <b-modal v-model="editProjectModal" size="lg" :title="$t('menuitems.projects.edit')" hide-footer>
      <form-wizard @on-complete="handleEditProjectSubmit" color="#556ee6" :finish-button-text="$t('menuitems.projects.form.finish')" :back-button-text="$t('menuitems.projects.form.back')" :next-button-text="$t('menuitems.projects.form.next')">
              <tab-content :before-change="beforeTabSwitchEdit" icon="bx bx-food-menu" style="height: 288px;" :title="$t('menuitems.projects.form.general')">
                <div class="text-danger mb-2">{{errorEditMsg}}</div>
                <div class="row">
                  <div class="col-12">
                    <div class="form-group row mb-3">
                      <label class="col-md-4 col-form-label" for="projectName"
                        >{{ $t('menuitems.projects.form.title') }} <sup><i class="mdi mdi-asterisk text-danger font-size-2"></i></sup></label
                      >
                      <div class="col-md-8">
                        <input
                          type="text"
                          class="form-control"
                          v-model="editProject.projectName"
                          name="projectName"
                          :class="{
                          'is-invalid':
                            errorEditCode == 1 || errorEditCode == 3
                          }"
                        />
                      </div>
                    </div>
                    <div class="form-group row mb-3">
                      <label class="col-md-4 col-form-label" for="description"
                        >{{ $t('menuitems.projects.form.description') }}</label
                      >
                      <div class="col-md-8">
                        <textarea
                          name="description"
                          class="form-control"
                          v-model="editProject.projectDescription"
                        ></textarea>
                      </div>
                    </div>

                    <div class="form-group row mb-3">
                      <label class="col-md-4 col-form-label" for="startDate"
                        > {{ $t('menuitems.projects.form.date') }} <sup><i class="mdi mdi-asterisk text-danger font-size-2"></i></sup></label
                      >
                      <div class="col-md-4">
                      <b-form-input
                      type="datetime-local"
                      v-model="editProject.startTime"
                      :class="{
                          'is-invalid':
                            errorEditCode == 2 || errorEditCode == 3
                          }"
                    ></b-form-input>
                      </div>
                      
                      <div class="col-md-4">
                     <b-form-input
                      v-model="editProject.deadlineTime"
                      type="datetime-local"
                      :class="{
                          'is-invalid':
                            errorEditCode == 2 || errorEditCode == 3
                          }"
                    ></b-form-input>
                      </div>
                    </div>
                    <div class="form-group row mb-3">
                      <label class="col-md-4 col-form-label" for="startDate"
                        >{{ $t('menuitems.projects.form.recordActivity') }}</label
                      >
                      
                      <div class="form-check form-switch form-switch-md ms-2 mt-2 col-md-1">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          v-model="editProject.recordScreenshot"
                          disabled
                        />
                      </div>
                      <label class="col-md-2 mt-1 col-form-label" for="screenshot"
                        >{{ $t('menuitems.projects.form.screenshot') }}</label
                      >
                      <div class="col-md-1"></div>
                       <div class="form-check form-switch form-switch-md mt-2 col-md-1">
                      
                        <!--<input
                          class="form-check-input"
                          type="checkbox"
                          v-model="editProject.recordWebcam"
                        />-->
                      
                      </div>
                      <!--<label class="col-md-2 mt-1 col-form-label" for="webcam"
                        >{{ $t('menuitems.projects.form.webcam') }}</label
                      >-->
                    </div>
                    <div class="form-group row mb-3">
                      <label class="col-md-4 col-form-label" for="startDate"
                        >{{ $t('menuitems.projects.form.mandatoryReporting') }}</label
                      >
                      
                      <div class="form-check form-switch form-switch-md ms-2 mt-2 col-md-1">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          v-model="editProject.mandatoryReporting"
                        />
                      </div>
                      
                    </div>
                  </div>
                  <!-- end col -->
                </div>
                <!-- end row -->
              </tab-content>
              <tab-content icon="bx bx-user-circle" style="height: 288px;" :title="$t('menuitems.projects.form.members')">
                <div class="row">
                  <div class="col-12">
                    <div class="form-group row mb-5">
                      <label class="col-md-3 col-form-label" for="name"
                        >{{ $t('menuitems.projects.form.addMembers') }}</label
                      >
                      <div class="col-md-9">
                        <multiselect v-model="editProject.employees" :options="employeeOptions" :custom-label="nameWithLang" track-by="value" :multiple="true"></multiselect>
                      </div>
                    </div>
                    <div class="form-group row mb-5">
                      <label class="col-md-3 col-form-label" for="surname"
                        >{{ $t('menuitems.projects.form.assignTeam') }}</label
                      >
                      <div class="col-md-9">
                       <multiselect v-model="editProject.teams" :options="teamOptions" :custom-label="nameWithLang" track-by="value" :multiple="true"></multiselect>
                      </div>
                    </div>

                    <div class="form-group row mb-5">
                      <label class="col-md-3 col-form-label" for="email"
                        >{{ $t('menuitems.projects.form.assignManager') }}</label
                      >
                      <div class="col-md-9">
                        <multiselect v-model="editProject.manager" :custom-label="nameWithLang" track-by="value" :options="employeeOptions" ></multiselect>
                      </div>
                    </div>
                  </div>
                  <!-- end col -->
                </div>
                <!-- end row -->
              </tab-content>
              <tab-content icon="bx bx-money" style="height: 288px;" :title="$t('menuitems.projects.form.budget')">
                <div class="row">
                  <div class="form-group row mb-3">
                      <label class="col-md-3 col-form-label" for="startDate"
                        >{{ $t('menuitems.projects.form.isBillable') }}</label
                      >
                      
                      <div class="form-check form-switch form-switch-md ms-2 mt-2 col-md-1">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          v-model="editProject.isBillable"
                        />
                      </div>
                      
                  </div>
                  <div class="form-group row mb-3">
                      <label class="col-md-3 col-form-label" for="startDate"
                        >{{ $t('menuitems.projects.form.billingType') }}</label
                      >
                      <div class="col-md-5">
                      <b-form-select
                          class="form-select mb-3"
                          :disabled="editProject.isBillable == false"
                          v-model="editProject.billingType"
                        >
                          <b-form-select-option :value="0"
                            >{{ $t('menuitems.projects.form.select') }}</b-form-select-option
                          >
                          <b-form-select-option value="1"
                            >{{ $t('menuitems.projects.form.fixed') }}</b-form-select-option
                          >
                          <b-form-select-option value="2"
                            >{{ $t('menuitems.projects.form.hourly') }}</b-form-select-option
                          >
                      </b-form-select>
                      </div>
                  </div>
                  <div class="form-group row mb-3">
                      <label class="col-md-3 col-form-label" for="startDate"
                        >{{ $t('menuitems.projects.form.payRate') }}</label
                      >
                      <div class="col-md-2">
                      <b-form-select
                          class="form-select mb-3"
                          :disabled="editProject.isBillable == false"
                          v-model="editProject.billingCurrency"
                        >
                          <b-form-select-option :value="0"
                            >{{ $t('menuitems.projects.form.select') }}</b-form-select-option
                          >
                          <b-form-select-option value="1"
                            >USD($)</b-form-select-option
                          >
                          <b-form-select-option value="2"
                            >INR(₹)</b-form-select-option
                          >
                      </b-form-select>
                      </div>
                      <div class="col-md-3">
                       <input
                          type="text"
                          class="form-control"
                          :disabled="editProject.isBillable == false"
                          v-model="editProject.payRate"
                        />
                      </div>
                  </div>
                  <div class="form-group row mb-3">
                      <label class="col-md-3 col-form-label" for="startDate"
                        >{{ $t('menuitems.projects.form.expectedTotalBudget') }}</label
                      >
                      <div class="col-md-2">
                      <b-form-select
                          class="form-select mb-3"
                          :disabled="editProject.isBillable == false"
                          v-model="editProject.billingCurrency"
                        >
                          <b-form-select-option :value="0"
                            >{{ $t('menuitems.projects.form.select') }}</b-form-select-option
                          >
                          <b-form-select-option value="1"
                            >USD($)</b-form-select-option
                          >
                          <b-form-select-option value="2"
                            >INR(₹)</b-form-select-option
                          >
                      </b-form-select>
                      </div>
                      <div class="col-md-3">
                       <input
                          type="text"
                          class="form-control"
                          :disabled="editProject.isBillable == false"
                          v-model="editProject.expectedTotalBudget"
                        />
                      </div>
                  </div>
                  <!-- end col -->
                </div>
                <!-- end row -->
              </tab-content>
            </form-wizard>
    </b-modal>

    <b-modal v-model="markCompleteModal" centered  :title="$t('menuitems.projects.markComplete')" hide-footer>
      <form @submit.prevent="handleMarkCompleteSubmit">
        <div class="row">
          <div class="col-12">
            <div class="form-group row mb-3">
              <label class="col-md-4 col-form-label" for="score"
                >{{ $t('menuitems.projects.modal.score') }} (1 - 10)</label
              >
              <div class="col-md-8">
                <input
                  type="number"
                  class="form-control"
                  min="0"
                  max="10"
                  v-model="markCompleteData.score"
                />
              </div>
            </div>
            <div class="form-group row mb-3">
              <label class="col-md-4 col-form-label" for="comments"
                >{{ $t('menuitems.projects.modal.comments') }}</label
              >
              <div class="col-md-8">
                <textarea
                  name="description"
                  class="form-control"
                  v-model="markCompleteData.comments"
                ></textarea>
              </div>
            </div>
            <div class="text-end mt-3">
              <b-button type="submit" variant="success" class="ms-1"
                >{{ $t('menuitems.projects.modal.submit') }}</b-button
              >
            </div>
          </div>
        </div>
      </form>
    </b-modal>

    <b-modal  v-model="membersModal" size="xl" :title="$t('menuitems.projects.members')" hide-footer>
    <div class="is-loading">
        <div class="preloader-component" v-show="membersLoader">
          <div class="status">
            <div class="spinner-chase">
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
            </div>
          </div>
        </div>
        <div style="height: calc(100vh - 210px)">
        <simplebar ref="current" style="max-height: calc(100vh - 210px);">
          <div class="table-responsive" style="height: calc(100vh - 210px);">
            <table class="table align-middle table-nowrap table-hover" >
              <thead class="table-light">
                <tr>
                  <th scope="col" >{{ $t('menuitems.projects.modal.name') }}</th>
                  <th scope="col" >{{ $t('menuitems.projects.modal.totalTime') }}</th>
                  <th scope="col" >{{ $t('menuitems.projects.modal.totalExpense') }}</th>
                  <!--<th scope="col">Productivity</th>-->
                  <th scope="col" >{{ $t('menuitems.projects.modal.lastReport') }}</th>
                  <th scope="col" >{{ $t('menuitems.projects.peopleProjectsModal.remarks') }}</th>
                </tr>
              </thead>
              
              <tbody>
                <tr v-for="data in projectMembers" :key="data.name">
                  <td class="col-md-2">
                    <span class="d-inline-block text-truncate" style="max-width: 150px">{{data.name}}</span>
                    <br/><span class="d-inline-block text-truncate text-secondary" style="max-width: 150px">{{data.email}}</span>
                    <br/><span class="d-inline-block text-truncate text-secondary" style="max-width: 150px">{{data.designation}}</span>
                  </td>
                  <td class="col-md-1">
                    {{data.totalTime}}
                  </td>
                  <td class="col-md-1">
                    <span v-if="data.currencyType == 1">$</span><span v-else>₹</span> {{data.totalExpense}}
                  </td>
                  <td class="col-md-2">
                    <div v-if="data.lastReport">
                      {{ $t('menuitems.projects.modal.workedFor') }} {{data.lastReport}} {{ $t('menuitems.projects.modal.on') }} {{data.lastReportDate}} {{ $t('menuitems.projects.modal.between') }} {{data.lastReportStartTime}} {{ $t('menuitems.projects.modal.and') }} {{data.lastReportEndTime}}. <span v-if="data.workDone != ''">{{ $t('menuitems.projects.modal.done') }} {{data.percentCompleted}}% {{ $t('menuitems.projects.modal.andReported') }}</span><br/>
                      <span v-if="data.workDone != ''"><i class="bx bxs-quote-alt-left"></i> {{data.workDone}}.<br/></span>
                    <span v-if="data.toDo != ''">{{data.toDo}}. <i class="bx bxs-quote-alt-right"></i></span>
                    </div>
                    <div v-else>
                      N.A
                    </div>
                  </td>
                  <td class="col-md-6">
                    <span v-if="data.remarks == 0" class="text-primary">N.A</span>
                    <span v-if="data.remarks == 1" class="text-primary">{{ $t('menuitems.projects.notStarted') }}</span>
                    <span v-if="data.remarks == 2" class="text-success">{{ $t('menuitems.projects.onTime') }}</span>
                    <span v-if="data.remarks == 3" class="text-warning">{{ $t('menuitems.projects.delayed') }}</span>
                    <span v-if="data.remarks == 4" class="text-success">{{ $t('menuitems.projects.completed') }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </simplebar>
        </div>
    </div>
    </b-modal>

    <b-modal v-model="todaysReportModal" size="xl" centered :title="$t('menuitems.projects.todaysReport')" hide-footer>
    <div class="row mb-3">
      <div class="col-md-10"></div>
      <div class="col-md-2">
        <date-picker
          v-model="reportsDate"
          :first-day-of-week="1"
          placeholder="Select Date"
          lang="en"
          @change="onDateChange()"
        ></date-picker>
      </div>
    </div>
    <div class="is-loading">
      <div class="preloader-component" v-show="todaysReportLoader">
        <div class="status">
          <div class="spinner-chase">
            <div class="chase-dot"></div>
            <div class="chase-dot"></div>
            <div class="chase-dot"></div>
            <div class="chase-dot"></div>
            <div class="chase-dot"></div>
            <div class="chase-dot"></div>
          </div>
        </div>
      </div>
      
      <div style="height: calc(100vh - 210px)">
        <simplebar ref="current" style="max-height: calc(100vh - 210px);">
          <div class="table-responsive" style="height: calc(100vh - 210px);">
            <table class="table align-middle table-nowrap table-hover" >
              <thead class="table-light">
                <tr>
                  <th scope="col" >{{ $t('menuitems.projects.modal.name') }}</th>
                  <th scope="col" >{{ $t('menuitems.projects.modal.workingTime') }}</th>
                  <th scope="col" >{{ $t('menuitems.projects.modal.expense') }}</th>
                  <th scope="col" >{{ $t('menuitems.projects.modal.progress') }}</th>
                  <th scope="col" >{{ $t('menuitems.projects.modal.report') }}</th>
                  <th scope="col" >{{ $t('menuitems.projects.modal.todo') }}</th>
                  <th scope="col" >{{ $t('menuitems.projects.modal.comments') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="data in todaysReport" :key="data.name">
                  <td>
                    <span class="d-inline-block text-truncate" style="max-width: 150px">{{data.name}}</span>
                    <br/><span class="d-inline-block text-truncate text-secondary" style="max-width: 150px">{{data.designation}}</span>
                  </td>
                  <td>
                    {{data.workingTime}} <span v-if="data.startTime && data.endTime">({{data.startTime}} - {{data.endTime}})</span>
                  </td>
                  <td>
                    <span v-if="data.currencyType == 1">$</span><span v-else>₹</span> {{data.expense}}
                  </td>
                  <td>
                    {{data.progress}}%
                  </td>
                  <td>
                    <span v-if="data.workDone && data.workDone != ''">{{data.workDone}}</span>
                    <span v-else>N.A</span>
                  </td>
                  <td>
                    <span v-if="data.toDo && data.toDo != ''">{{data.toDo}}</span>
                    <span v-else>N.A</span>
                  </td>
                  <td>
                    <span v-if="data.comments && data.comments != ''">{{data.comments}}</span>
                    <span v-else>N.A</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          </simplebar>
      </div>
    </div>
    </b-modal>
    <!-- end row -->
  </Layout>
</template>
<style scoped>
.is-loading {
  position: relative;
}
.preloader-component {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #fff;
  z-index: 999;
  width: 100%;
}
.status {
  width: 40px;
  height: 40px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -20px 0 0 -20px;
}
</style>